export const prepareTranslations = () => ({});
export const mergeProperties = ({ cardData, translations }) => ({
  ...cardData,
  ...translations,
});
export const getUrlIngredients = () => [];
export const getAnalyticsPlacements = () => [];
export const getAnalyticsActions = () => [];
export const getBuyingToolsIngredients = () => [];
